require('./application-page.scss');

const ApplicationPageComponent = {
    selector: 'sbApplicationPage',
    template: require('./application-page.html'),
    transclude: {
        content: 'sbApplicationContent',
    },
};

export default ApplicationPageComponent;



// WEBPACK FOOTER //
// ./src/app/components/application-page/index.js